<script setup lang="ts">
import { useConfirm } from '@/composables/useConfirm';

const { state, answer } = useConfirm();

function onKey(e: KeyboardEvent): void {
  if (!state.open) return;
  if (e.key === 'Escape') answer(false);
  if (e.key === 'Enter') answer(true);
}

if (typeof window !== 'undefined') {
  window.addEventListener('keydown', onKey);
}
</script>

<template>
  <Teleport to="body">
    <div v-if="state.open" class="modal-backdrop" data-test-id="confirm-host" @click.self="answer(false)">
      <div class="confirm">
        <h2 class="confirm__title">{{ state.options?.title }}</h2>
        <!-- pre-line, because a consent notice that lists what an action
             destroys needs its list to stay a list. wiring.css is copied
             verbatim from the prototype, so the rule lives here instead.
             Bodies with no newline are unaffected. -->
        <p v-if="state.options?.body" class="confirm__body" style="white-space: pre-line">{{ state.options.body }}</p>
        <div class="confirm__actions">
          <button class="btn" data-test-id="confirm-cancel" @click="answer(false)">
            {{ state.options?.cancelLabel ?? 'Cancel' }}
          </button>
          <button
            class="btn btn--primary"
            :style="state.options?.danger ? 'background: var(--color-red); border-color: var(--color-red);' : ''"
            data-test-id="confirm-ok"
            @click="answer(true)"
          >
            {{ state.options?.confirmLabel ?? 'Confirm' }}
          </button>
        </div>
      </div>
    </div>
  </Teleport>
</template>
